<template>
  <b-card no-body class="house-filter-v2">

    <!-- ── Mobile Top Bar (< lg) ── -->
    <div class="d-lg-none filter-topbar px-1 py-75">
      <div class="d-flex align-items-center" style="gap: 0.5rem;">
        <div class="position-relative flex-grow-1">
          <b-input-group>
            <input
              v-model="Data.keyword"
              type="text"
              class="form-control"
              :style="Data.keyword ? 'border-right: none !important;' : ''"
              placeholder="Search code, house name, pin name..."
              autocomplete="off"
              @keyup.enter="applyFilter"
            />
            <b-input-group-append v-if="Data.keyword">
              <span class="input-group-text kw-clear-wrap" @mousedown.prevent="Data.keyword = ''; applyFilter(false)">
                <span class="kw-clear-circle"><feather-icon icon="XIcon" size="10" /></span>
              </span>
            </b-input-group-append>
            <b-input-group-append>
              <b-button variant="primary" @click="applyFilter">
                <feather-icon icon="SearchIcon" size="14" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <b-button variant="outline-secondary" size="sm" class="filter-toggle-btn" @click="collapsed = !collapsed">
          <feather-icon :icon="collapsed ? 'SlidersIcon' : 'ChevronUpIcon'" size="14" />
        </b-button>
      </div>
    </div>

    <!-- ── Desktop Top Bar (>= lg) ── -->
    <div class="d-none d-lg-block filter-topbar px-1 pt-75 pb-50">

      <div class="d-flex justify-content-between align-items-center mb-75">
        <span class="font-weight-bold" style="font-size: 0.95rem; color: #5e5873;">Quick Search</span>
        <div class="d-flex align-items-center" style="gap: 0.5rem;">
          <b-dropdown v-if="templateData.length" variant="outline-secondary" text="Templates" size="sm" right>
            <b-dropdown-item
              v-for="t in templateData"
              :key="t.id"
              link-class="d-flex align-items-center pr-2"
              style="min-width: 180px;"
              @click="loadTemplate(t)"
            >
              <span class="flex-grow-1 mr-3">{{ t.title }}</span>
              <feather-icon icon="Trash2Icon" size="13" class="text-danger cursor-pointer flex-shrink-0" @click.stop="deleteTemplate(t.id)" />
            </b-dropdown-item>
          </b-dropdown>
          <b-button variant="primary" size="sm" :to="{ name: 'house-create' }">
            <feather-icon icon="PlusIcon" size="14" class="mr-25" />New House
          </b-button>
        </div>
      </div>

      <div class="d-flex align-items-flex-end flex-wrap" style="gap: 0.5rem; align-items: flex-end;">

        <div class="position-relative topbar-field-code">
          <label class="topbar-input-label">Property</label>
          <div class="position-relative">
            <input
              v-model="search"
              type="text"
              class="form-control topbar-clearable"
              placeholder="Search Property Pin"
              autocomplete="off"
              @input="onInput($event.target.value)"
              @keydown.down.prevent="moveDown"
              @keydown.up.prevent="moveUp"
              @keydown.enter.prevent="selectItem(activeIndex)"
              @blur="hideSuggestions"
            />
            <span v-if="search" class="topbar-clear-btn" @mousedown.prevent="search = ''; selectedPropertyId = null; Data.place_id = null; filtered = []; applyFilter(false)"><feather-icon icon="XIcon" size="10" /></span>
            <ul v-if="showSuggestions && filtered.length" class="list-group position-absolute zindex-dropdown shadow-sm" style="top: 100%; left: 0; min-width: 100%; width: max-content; max-width: 320px; max-height: 200px; overflow-y: auto;">
              <li v-for="(item, index) in filtered" :key="item.id || index" class="list-group-item list-group-item-action py-1" :class="{ active: index === activeIndex }" @mousedown.prevent="selectItem(index)">
                {{ item.name[currentLocale] }}
              </li>
            </ul>
          </div>
        </div>

        <div class="position-relative topbar-field-owner">
          <label class="topbar-input-label">Owner</label>
          <div class="position-relative">
            <input
              v-model="searchOwner"
              type="text"
              class="form-control topbar-clearable"
              placeholder="Search Owner"
              autocomplete="off"
              @input="onInputOwner($event.target.value)"
              @keydown.down.prevent="moveDownOwner"
              @keydown.up.prevent="moveUpOwner"
              @keydown.enter.prevent="selectOwner(activeIndexOwner)"
              @blur="hideOwnerSuggestions"
            />
            <span v-if="searchOwner" class="topbar-clear-btn" @mousedown.prevent="searchOwner = ''; selectedOwnerId = null; Data.owner_id = null; filteredOwner = []; applyFilter(false)"><feather-icon icon="XIcon" size="10" /></span>
            <ul v-if="showOwnerSuggestions && filteredOwner.length" class="list-group position-absolute zindex-dropdown shadow-sm" style="top: 100%; left: 0; width: 100%; max-height: 200px; overflow-y: auto;">
              <li v-for="(item, index) in filteredOwner" :key="`${item.id}-${index}`" class="list-group-item list-group-item-action py-1" :class="{ active: index === activeIndexOwner }" @mousedown.prevent="selectOwner(index)">
                {{ item.firstname }} {{ item.lastname }}
              </li>
            </ul>
          </div>
        </div>

        <div class="topbar-field-sm">
          <label class="topbar-input-label">Unit / House No.</label>
          <div class="position-relative">
            <input v-model="Data.unit" type="text" class="form-control topbar-clearable" placeholder="no." autocomplete="off" @keyup.enter="applyFilter" @blur="applyFilter(false)" />
            <span v-if="Data.unit" class="topbar-clear-btn" @mousedown.prevent="Data.unit = ''; applyFilter(false)"><feather-icon icon="XIcon" size="10" /></span>
          </div>
        </div>

        <div class="topbar-field-sm">
          <label class="topbar-input-label">Floor</label>
          <div class="position-relative">
            <input v-model="Data.floor" type="text" class="form-control topbar-clearable" placeholder="floor" autocomplete="off" @keyup.enter="applyFilter" @blur="applyFilter(false)" />
            <span v-if="Data.floor" class="topbar-clear-btn" @mousedown.prevent="Data.floor = ''; applyFilter(false)"><feather-icon icon="XIcon" size="10" /></span>
          </div>
        </div>

        <div class="d-flex ml-auto align-items-center" style="gap: 0.25rem; flex-shrink: 0; align-self: center;">
          <b-button variant="flat-secondary" size="sm" class="topbar-icon-btn" @click="collapsed = !collapsed">
            <feather-icon :icon="collapsed ? 'SlidersIcon' : 'ChevronUpIcon'" size="14" />
          </b-button>
          <b-button variant="flat-primary" size="sm" class="topbar-icon-btn" @click="saveTemplate">
            <feather-icon icon="SaveIcon" size="14" />
          </b-button>
        </div>
      </div>
    </div>

    <!-- ── Active filter capsules ── -->
    <div v-if="chips.length && collapsed" class="capsule-row px-1 py-50 border-top">
      <b-badge
        v-for="chip in chips"
        :key="chip.key"
        class="capsule-tag mr-25 mb-25 d-inline-flex align-items-center cursor-pointer"
        @click="clearChip(chip.key)"
      >
        <span class="capsule-label">{{ chip.label }}</span>
        <span class="capsule-value">{{ chip.value }}</span>
        <feather-icon icon="XIcon" size="10" class="ml-25 capsule-x" />
      </b-badge>
      <b-badge class="capsule-tag capsule-clear mr-25 mb-25 d-inline-flex align-items-center cursor-pointer" @click="clearFilter">
        <feather-icon icon="XIcon" size="10" class="mr-25" />Clear All
      </b-badge>
    </div>

    <!-- ── Collapsible filter body ── -->
    <b-collapse :visible="!collapsed">
      <hr class="my-0" />
      <div class="filter-body px-1 pt-1 pb-75">

        <!-- Row 1: Action · House Type · Bedroom -->
        <b-row>
          <b-col cols="6" sm="4" md="3" class="mb-1">
            <label class="field-label">Action</label>
            <div class="toggle-group border rounded">
              <b-button
                v-for="opt in actionOptions"
                :key="opt.value"
                :variant="actionSelected.includes(opt.value) ? 'primary' : 'flat-secondary'"
                class="toggle-btn"
                @click="toggleAction(opt.value)"
              >{{ opt.text }}</b-button>
            </div>
          </b-col>

          <b-col cols="6" sm="4" md="3" class="mb-1">
            <label class="field-label">House Type</label>
            <v-select
              v-model="Data.property_type"
              :options="propertyTypeOptions"
              label="title"
              :reduce="o => o.id"
              placeholder="All"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            />
          </b-col>

          <b-col cols="12" sm="4" md="6" class="mb-1">
            <label class="field-label">Bedroom</label>
            <div class="toggle-group border rounded">
              <b-button
                v-for="(label, i) in bedroomLabels"
                :key="i"
                :variant="bedroomSelected.includes(i) ? 'primary' : 'flat-secondary'"
                class="toggle-btn"
                @click="toggleBedroom(i)"
              >{{ label }}</b-button>
            </div>
          </b-col>
        </b-row>

        <!-- Row 2: Price · Useable Area · Land Area -->
        <b-row>
          <b-col cols="12" sm="6" md="4" class="mb-1">
            <label class="field-label">Price (฿)</label>
            <div ref="priceDropdownRef" class="position-relative">
              <b-input-group class="range-group">
                <input type="text" :value="fmt(Data.priceMin)" placeholder="Min" autocomplete="off" class="form-control text-center" @focus="openDropdown('price')" @input="onFmtInput($event, 'priceMin')" />
                <b-input-group-text class="range-sep">–</b-input-group-text>
                <input type="text" :value="fmt(Data.priceMax)" placeholder="Max" autocomplete="off" class="form-control text-center" @focus="openDropdown('price')" @input="onFmtInput($event, 'priceMax')" />
              </b-input-group>
              <div v-if="showDropdown" class="range-dropdown border rounded bg-white shadow-sm">
                <b-list-group flush>
                  <b-list-group-item v-for="(range, i) in getPriceRage()" :key="i" button class="d-flex align-items-center py-1" @click="selectRange(range)">
                    <b-form-radio :value="range" v-model="selectedRange" class="mr-2" name="priceRangeRadio" />{{ range.text }}
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </b-col>

          <b-col cols="12" sm="6" md="4" class="mb-1">
            <label class="field-label">Useable Area (sq.m)</label>
            <div ref="sqmDropdownRef" class="position-relative">
              <b-input-group class="range-group">
                <input type="text" :value="fmt(Data.sqm_min)" placeholder="Min" autocomplete="off" class="form-control text-center" @focus="openDropdown('sqm')" @input="onFmtInput($event, 'sqm_min')" />
                <b-input-group-text class="range-sep">–</b-input-group-text>
                <input type="text" :value="fmt(Data.sqm_max)" placeholder="Max" autocomplete="off" class="form-control text-center" @focus="openDropdown('sqm')" @input="onFmtInput($event, 'sqm_max')" />
              </b-input-group>
              <div v-if="showSqmDropdown" class="range-dropdown border rounded bg-white shadow-sm">
                <b-list-group flush>
                  <b-list-group-item v-for="(range, i) in sqmRanges" :key="i" button class="d-flex align-items-center py-1" @click="selectSqmRange(range)">
                    <b-form-radio :value="range" v-model="selectedSqmRange" class="mr-2" name="sqmRangeRadio" />{{ range.text }}
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </b-col>

          <b-col cols="12" sm="6" md="4" class="mb-1">
            <label class="field-label">Land Area (sq.w)</label>
            <div ref="sqwDropdownRef" class="position-relative">
              <b-input-group class="range-group">
                <input type="text" :value="fmt(Data.min_land_area)" placeholder="Min" autocomplete="off" class="form-control text-center" @focus="openDropdown('sqw')" @input="onFmtInput($event, 'min_land_area')" />
                <b-input-group-text class="range-sep">–</b-input-group-text>
                <input type="text" :value="fmt(Data.max_land_area)" placeholder="Max" autocomplete="off" class="form-control text-center" @focus="openDropdown('sqw')" @input="onFmtInput($event, 'max_land_area')" />
              </b-input-group>
              <div v-if="showSqwDropdown" class="range-dropdown border rounded bg-white shadow-sm">
                <b-list-group flush>
                  <b-list-group-item v-for="(range, i) in sqwRanges" :key="i" button class="d-flex align-items-center py-1" @click="selectSqwRange(range)">
                    <b-form-radio :value="range" v-model="selectedSqwRange" class="mr-2" name="sqwRangeRadio" />{{ range.text }}
                  </b-list-group-item>
                </b-list-group>
              </div>
            </div>
          </b-col>
        </b-row>

        <!-- Row 3: Zone · District · Transit -->
        <b-row>
          <b-col cols="12" sm="6" md="3" class="mb-1">
            <label class="field-label">Zone</label>
            <v-select
              v-model="zoneSelected"
              multiple
              label="title"
              :reduce="o => o.id"
              :options="zoneOptions.map(g => ({ title: g.name[currentLocale], id: g.id }))"
              placeholder="All zones"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              @input="onZoneChange"
            />
          </b-col>

          <b-col cols="6" sm="3" md="2" class="mb-1">
            <label class="field-label">Province</label>
            <v-select
              v-model="selectedProvinceId"
              label="name"
              :reduce="o => o.id"
              :options="provinceOptions"
              placeholder="Any"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
              @input="onProvinceChange"
            />
          </b-col>

          <b-col cols="6" sm="3" md="2" class="mb-1">
            <label class="field-label">District</label>
            <v-select
              v-model="Data.amphure_id"
              label="name"
              :reduce="o => o.id"
              :options="amphureOptions"
              :disabled="!selectedProvinceId"
              placeholder="Any"
              :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
            />
          </b-col>

          <b-col cols="12" md="5" class="mb-1">
            <label class="field-label">Transit</label>
            <b-tabs small class="filter-tabs">
              <b-tab title="BTS">
                <v-select v-model="BTSSelected" multiple label="name" :reduce="o => o.id" :options="bts" placeholder="BTS stations..." :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" @input="onBTSChange" />
              </b-tab>
              <b-tab title="MRT">
                <v-select v-model="MRTSelected" multiple label="name" :reduce="o => o.id" :options="mrt" placeholder="MRT stations..." :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" @input="onMRTChange" />
              </b-tab>
              <b-tab title="ARL">
                <v-select v-model="ARLSelected" multiple label="name" :reduce="o => o.id" :options="arl.map(a => ({ name: a.name[currentLocale], id: a.id }))" placeholder="ARL stations..." :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'" @input="onARLChange" />
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>

        <!-- Row 4 (mobile / tablet only — desktop has these in the top bar) -->
        <b-row class="d-lg-none">
          <b-col cols="12" sm="6" class="mb-1 position-relative">
            <label class="field-label">Property</label>
            <input
              v-model="search"
              type="text"
              class="form-control"
              placeholder="Search Property Pin"
              autocomplete="off"
              @input="onInput($event.target.value)"
              @keydown.down.prevent="moveDown"
              @keydown.up.prevent="moveUp"
              @keydown.enter.prevent="selectItem(activeIndex)"
              @blur="hideSuggestions"
            />
            <ul v-if="showSuggestions && filtered.length" class="list-group position-absolute zindex-dropdown shadow-sm" style="width: calc(100% - 2rem); max-height: 200px; overflow-y: auto;">
              <li v-for="(item, index) in filtered" :key="item.id || index" class="list-group-item list-group-item-action py-1" :class="{ active: index === activeIndex }" @mousedown.prevent="selectItem(index)">
                {{ item.name[currentLocale] }}
              </li>
            </ul>
          </b-col>

          <b-col cols="12" sm="6" class="mb-1 position-relative">
            <label class="field-label">Owner</label>
            <input
              v-model="searchOwner"
              type="text"
              class="form-control"
              placeholder="Search Owner"
              autocomplete="off"
              @input="onInputOwner($event.target.value)"
              @keydown.down.prevent="moveDownOwner"
              @keydown.up.prevent="moveUpOwner"
              @keydown.enter.prevent="selectOwner(activeIndexOwner)"
              @blur="hideOwnerSuggestions"
            />
            <ul v-if="showOwnerSuggestions && filteredOwner.length" class="list-group position-absolute zindex-dropdown shadow-sm" style="width: calc(100% - 2rem); max-height: 200px; overflow-y: auto;">
              <li v-for="(item, index) in filteredOwner" :key="`${item.id}-${index}`" class="list-group-item list-group-item-action py-1" :class="{ active: index === activeIndexOwner }" @mousedown.prevent="selectOwner(index)">
                {{ item.firstname }} {{ item.lastname }}
              </li>
            </ul>
          </b-col>

          <b-col cols="6" class="mb-1">
            <label class="field-label">Unit / House No.</label>
            <input v-model="Data.unit" type="text" class="form-control" placeholder="Search Unit no." @keyup.enter="applyFilter" @blur="applyFilter(false)" />
          </b-col>

          <b-col cols="6" class="mb-1">
            <label class="field-label">Floor</label>
            <input v-model="Data.floor" type="text" class="form-control" placeholder="Floor" @keyup.enter="applyFilter" @blur="applyFilter(false)" />
          </b-col>
        </b-row>

        <!-- Row 5: Expire · Last Updated -->
        <b-row>
          <b-col cols="12" sm="6" md="4" class="mb-1">
            <label class="field-label">Expire Date</label>
            <date-range-picker ref="expirePicker" opens="right" :locale-data="localeData" :minDate="Data.minDateExpire" :maxDate="Data.maxDateExpire" :ranges="false" :autoApply="true" v-model="dateRange" @update="updateValues" class="w-100">
              <template v-slot:input="picker"><div class="text-center w-100">{{ picker.startDate | fmtDate }} – {{ picker.endDate | fmtDate }}</div></template>
              <template v-slot:footer>
                <div class="text-center p-2 border-top">
                  <b-button size="sm" variant="outline-danger" @click="clearExpireDateRange">Clear</b-button>
                </div>
              </template>
            </date-range-picker>
          </b-col>

          <b-col cols="12" sm="6" md="4" class="mb-1">
            <label class="field-label">
              Last Updated Range
              <feather-icon icon="InfoIcon" size="12" class="text-muted ml-25" v-b-tooltip.hover title="Filters by when the record was last modified, not a real move-in / availability date." />
            </label>
            <date-range-picker ref="avlPicker" opens="left" :locale-data="localeData" :minDate="Data.minDateAvl" :maxDate="Data.maxDateAvl" :ranges="false" :autoApply="true" v-model="dateAvlRange" @update="updateAvlValues" class="w-100">
              <template v-slot:input="picker"><div class="text-center w-100">{{ picker.startDate | fmtDate }} – {{ picker.endDate | fmtDate }}</div></template>
              <template v-slot:footer>
                <div class="text-center p-2 border-top">
                  <b-button size="sm" variant="outline-danger" @click="clearAvlDateRange">Clear</b-button>
                </div>
              </template>
            </date-range-picker>
          </b-col>
        </b-row>

        <!-- Facility & Amenity (collapsible) -->
        <div class="mt-25">
          <b-button variant="link" size="sm" class="p-0 text-muted d-flex align-items-center mb-75" style="text-decoration: none;" @click="showFac = !showFac">
            <feather-icon :icon="showFac ? 'ChevronUpIcon' : 'ChevronDownIcon'" size="13" class="mr-25" />
            Facility &amp; Amenity
          </b-button>
          <b-collapse :visible="showFac">
            <b-tabs class="filter-tabs">
              <b-tab title="Facility">
                <b-form-checkbox-group v-model="facilitySelected" :options="facs.map(g => ({ text: g.name[currentLocale], value: g.id }))" class="checkbox-grid mb-1" @change="onFacilityChange" />
              </b-tab>
              <b-tab title="Amenity">
                <b-form-checkbox-group v-model="amenitySelected" :options="amnls.map(g => ({ text: g.name[currentLocale], value: g.id }))" class="checkbox-grid mb-1" @change="onAmenityChange" />
              </b-tab>
            </b-tabs>
          </b-collapse>
        </div>

        <!-- Footer -->
        <div class="d-flex justify-content-end align-items-center pt-75 border-top mt-75" style="gap: 0.5rem;">
          <b-button variant="outline-secondary" size="sm" @click="clearFilter">
            <feather-icon icon="XIcon" size="13" class="mr-25" />Clear All
          </b-button>
          <b-button variant="primary" size="sm" @click="applyFilter">
            <feather-icon icon="SearchIcon" size="13" class="mr-25" />Search
          </b-button>
        </div>

      </div>
    </b-collapse>
  </b-card>
</template>

<script>
import axios from '@axios'
import {
  BCard, BCollapse, BButton, BRow, BCol, BFormCheckboxGroup, BFormRadio,
  BInputGroup, BInputGroupAppend, BInputGroupText, BTabs, BTab, BListGroup, BListGroupItem,
  BDropdown, BDropdownItem, BBadge, VBTooltip,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import router from '@/router'
import moment from 'moment'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'

export default {
  name: 'HouseFilter',
  components: {
    BCard, BCollapse, BButton, BRow, BCol, BFormCheckboxGroup, BFormRadio,
    BInputGroup, BInputGroupAppend, BInputGroupText, BTabs, BTab, BListGroup, BListGroupItem,
    BDropdown, BDropdownItem, BBadge, vSelect, DateRangePicker,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  props: {
    advfilter: { type: [Object, String, Array], default: null },
  },
  filters: {
    fmtDate(v) { return v ? moment(v).format('DD/MM/YYYY') : '–' },
  },
  data() {
    const route = router.currentRoute.query

    const blankData = {
      keyword: route.keyword || '',
      action_id: route.actionId || '',
      bedrooms: route.bedroom || '',
      property_type: route.property_type || null,
      priceMin: route.minPrice || null,
      priceMax: route.maxPrice || null,
      sqm_min: route.minUseableArea || '',
      sqm_max: route.maxUseableArea || '',
      min_land_area: route.minLandArea || null,
      max_land_area: route.maxLandArea || null,
      bts_ids: route.bts_ids || '',
      mrt_ids: route.mrt_ids || '',
      arl_ids: route.arl_ids || '',
      zones: route.zones || '',
      minDateExpire: route.expire_start ? moment(route.expire_start).subtract(1, 'years').toDate() : null,
      maxDateExpire: route.expire_end ? moment(route.expire_end).add(1, 'years').toDate() : null,
      minDateAvl: route.avl_start ? moment(route.avl_start).subtract(1, 'years').toDate() : null,
      maxDateAvl: route.avl_end ? moment(route.avl_end).add(1, 'years').toDate() : null,
      bts_id: route.bts_id || '',
      mrt_id: route.mrt_id || '',
      arl_id: route.arl_id || '',
      zone_id: route.zone_id || '',
      amphure_id: route.amphure_id || null,
      place_id: route.place_id || null,
      owner_id: route.ownerId || null,
      unit: route.unit || '',
      floor: route.floor || '',
      fac_id: route.fac_id || '',
      amenity_id: route.amenity_id || '',
    }

    return {
      collapsed: true,
      showFac: false,

      actionSelected: [],
      bedroomSelected: [],
      BTSSelected: [],
      MRTSelected: [],
      ARLSelected: [],
      zoneSelected: [],
      facilitySelected: [],
      amenitySelected: [],
      selectedProvinceId: null,

      bedroomLabels: ['Studio', '1', '2', '3', '4+'],
      actionOptions: [{ value: '2,4', text: 'Rent' }, { value: '2,3', text: 'Sale' }],
      Data: JSON.parse(JSON.stringify(blankData)),

      zoneOptions: [],
      provinceOptions: [],
      amphureOptions: [],
      bts: [],
      mrt: [],
      arl: [],
      amnls: [],
      facs: [],
      propertyTypeOptions: [],
      templateData: [],

      priceSaleRanges: [
        { min: null, max: null, text: 'All Price', value: '' },
        { min: null, max: 2000000, text: '< 2 M', value: '0-2' },
        { min: 2000000, max: 3000000, text: '2 - 3 M', value: '2-3' },
        { min: 3000000, max: 5000000, text: '3 - 5 M', value: '3-5' },
        { min: 5000000, max: 8000000, text: '5 - 8 M', value: '5-8' },
        { min: 8000000, max: 10000000, text: '8 - 10 M', value: '8-10' },
        { min: 10000000, max: 15000000, text: '10 - 15 M', value: '10-15' },
        { min: 15000000, max: 20000000, text: '15 - 20 M', value: '15-20' },
        { min: 20000000, max: null, text: '> 20 M', value: '20-0' },
      ],
      priceRentRanges: [
        { min: null, max: null, text: 'All Price', value: '' },
        { min: null, max: 20000, text: '< 20,000', value: '0-20000' },
        { min: 20000, max: 30000, text: '20,000 - 30,000', value: '20000-30000' },
        { min: 30000, max: 50000, text: '30,000 - 50,000', value: '30000-50000' },
        { min: 50000, max: 100000, text: '50,000 - 100,000', value: '50000-100000' },
        { min: 100000, max: 150000, text: '100,000 - 150,000', value: '100000-150000' },
        { min: 150000, max: null, text: '> 150,000', value: '150000-0' },
      ],
      sqmRanges: [
        { min: null, max: null, text: 'All Size', value: '' },
        { min: 20, max: 30, text: '20 - 30 sqm.', value: '20-30' },
        { min: 30, max: 40, text: '30 - 40 sqm.', value: '30-40' },
        { min: 40, max: 80, text: '40 - 80 sqm.', value: '40-80' },
        { min: 80, max: 150, text: '80 - 150 sqm.', value: '80-150' },
      ],
      sqwRanges: [
        { min: null, max: null, text: 'All Size', value: '' },
        { min: 100, max: 200, text: '100 - 200 sq.w', value: '100-200' },
        { min: 200, max: 300, text: '200 - 300 sq.w', value: '200-300' },
        { min: 300, max: null, text: '300 - Max sq.w', value: '300-0' },
      ],

      dateRange: { startDate: null, endDate: null },
      dateAvlRange: { startDate: null, endDate: null },
      localeData: { firstDay: 1, format: 'DD-MM-YYYY', applyLabel: 'Apply', cancelLabel: 'Cancel' },

      search: '',
      filtered: [],
      showSuggestions: false,
      activeIndex: -1,
      selectedPropertyId: null,

      searchOwner: '',
      selectedOwnerId: null,
      showOwnerSuggestions: false,
      filteredOwner: [],
      activeIndexOwner: -1,

      showDropdown: false,
      showSqmDropdown: false,
      showSqwDropdown: false,
      selectedRange: null,
      selectedSqmRange: null,
      selectedSqwRange: null,

      userData: JSON.parse(localStorage.getItem('userData')),
    }
  },
  computed: {
    currentLocale() {
      return this.$i18n.locale
    },
    chips() {
      const q = this.$route.query
      const list = []

      if (q.keyword) list.push({ key: 'keyword', label: 'Search', value: q.keyword })

      if (q.actionId) {
        const ids = q.actionId.toString().split(',').map(Number)
        const label = ids.includes(4) && ids.includes(3) ? 'Sale & Rent' : ids.includes(4) ? 'Rent' : ids.includes(3) ? 'Sale' : 'Sale & Rent'
        list.push({ key: 'action', label: 'Action', value: label })
      }

      if (q.property_type) {
        const pt = this.propertyTypeOptions.find(o => String(o.id) === String(q.property_type))
        list.push({ key: 'property_type', label: 'House Type', value: pt ? pt.title : q.property_type })
      }

      if (q.bedroom) {
        const value = q.bedroom.split(',').map(n => this.bedroomLabels[Number(n)] ?? n).join(', ')
        list.push({ key: 'bedroom', label: 'Bedroom', value })
      }

      if (q.minPrice || q.maxPrice) {
        const min = q.minPrice ? '฿' + Number(q.minPrice).toLocaleString() : '฿0'
        const max = q.maxPrice ? '฿' + Number(q.maxPrice).toLocaleString() : '∞'
        list.push({ key: 'price', label: 'Price', value: `${min} – ${max}` })
      }

      if (q.minUseableArea || q.maxUseableArea) {
        list.push({ key: 'sqm', label: 'Useable Area', value: `${q.minUseableArea || 0} – ${q.maxUseableArea || '∞'} sqm.` })
      }

      if (q.minLandArea || q.maxLandArea) {
        list.push({ key: 'land', label: 'Land Area', value: `${q.minLandArea || 0} – ${q.maxLandArea || '∞'} sq.w` })
      }

      if (q.zones || q.zone_id) {
        const n = String(q.zones || q.zone_id).split(',').filter(Boolean).length
        list.push({ key: 'zone', label: 'Zone', value: `${n} selected` })
      }
      if (q.amphure_id) {
        const a = this.amphureOptions.find(o => String(o.id) === String(q.amphure_id))
        list.push({ key: 'district', label: 'District', value: a ? a.name : q.amphure_id })
      }
      if (q.bts_ids || q.bts_id) {
        const n = String(q.bts_ids || q.bts_id).split(',').filter(Boolean).length
        list.push({ key: 'bts', label: 'BTS', value: `${n} selected` })
      }
      if (q.mrt_ids || q.mrt_id) {
        const n = String(q.mrt_ids || q.mrt_id).split(',').filter(Boolean).length
        list.push({ key: 'mrt', label: 'MRT', value: `${n} selected` })
      }
      if (q.arl_ids || q.arl_id) {
        const n = String(q.arl_ids || q.arl_id).split(',').filter(Boolean).length
        list.push({ key: 'arl', label: 'ARL', value: `${n} selected` })
      }

      if (q.unit) list.push({ key: 'unit', label: 'Unit', value: q.unit })
      if (q.floor) list.push({ key: 'floor', label: 'Floor', value: q.floor })
      if (q.ownerId) list.push({ key: 'owner', label: 'Owner', value: this.searchOwner || q.ownerId })
      if (q.place_id) list.push({ key: 'place', label: 'Property', value: this.search || q.place_id })

      if (q.fac_id) {
        const n = q.fac_id.split(',').filter(Boolean).length
        list.push({ key: 'facility', label: 'Facility', value: `${n} selected` })
      }
      if (q.amenity_id) {
        const n = q.amenity_id.split(',').filter(Boolean).length
        list.push({ key: 'amenity', label: 'Amenity', value: `${n} selected` })
      }

      if (q.expire_start) list.push({ key: 'expire', label: 'Expire', value: `${q.expire_start} – ${q.expire_end}` })
      if (q.avl_start) list.push({ key: 'updated', label: 'Last Updated', value: `${q.avl_start} – ${q.avl_end}` })

      return list
    },
  },
  mounted() {
    this.getZones()
    this.getBts()
    this.getMrt()
    this.getARL()
    this.getAmenities()
    this.getFacilities()
    this.getPlaceTypeData()
    this.getTemplates()
    this.fetchProvinces()

    document.addEventListener('mousedown', this.handleClickOutside)

    const route = router.currentRoute.query

    if (route.actionId) {
      this.actionSelected = route.actionId === '2' ? [] : [route.actionId]
    }

    if (route.bedroom) {
      this.bedroomSelected = route.bedroom.split(',').map(Number)
    }

    if (route.place_id) {
      this.filterPropertyId(route.place_id)
    }

    if (route.ownerId) {
      this.filterOwner(route.ownerId)
    }

    if (route.expire_start && route.expire_end) {
      this.dateRange = { startDate: moment(route.expire_start), endDate: moment(route.expire_end) }
    }

    if (route.avl_start && route.avl_end) {
      this.dateAvlRange = { startDate: moment(route.avl_start), endDate: moment(route.avl_end) }
    }

    const parseIdList = (key1, key2, target) => {
      if (route[key1]) {
        this[target] = route[key1].split(',').map(Number)
      } else if (key2 && route[key2]) {
        this[target] = route[key2].split(',').map(Number)
      }
    }

    parseIdList('bts_id', 'bts_ids', 'BTSSelected')
    parseIdList('mrt_id', 'mrt_ids', 'MRTSelected')
    parseIdList('arl_id', 'arl_ids', 'ARLSelected')
    parseIdList('zone_id', 'zones', 'zoneSelected')
    parseIdList('fac_id', '', 'facilitySelected')
    parseIdList('amenity_id', '', 'amenitySelected')
  },
  beforeDestroy() {
    document.removeEventListener('mousedown', this.handleClickOutside)
  },
  methods: {
    async filterOwner(id) {
      axios.get(`/property/v1/owner/${id}`).then(response => {
        const data = response?.data?.data[0]
        if (!data) return
        this.searchOwner = `${data.firstname} ${data.lastname}`
        this.selectedOwnerId = data.id
        this.Data.owner_id = data.id
      }).catch(() => {
        this.filteredOwner = []
      })
    },
    async filterPropertyId(id) {
      const response = await axios.post(`/v1/house-pin/search`, { byID: id })
      const propertyData = response?.data?.data[0]
      if (!propertyData) return
      this.search = propertyData.name[this.currentLocale]
      this.selectedPropertyId = propertyData.id
      this.Data.place_id = propertyData.id
      this.filtered = []
    },
    updateValues({ startDate, endDate } = {}) {
      if (startDate && endDate) {
        this.dateRange = { startDate: moment(startDate), endDate: moment(endDate) }
        this.Data.minDateExpire = moment(startDate).format('YYYY-MM-DD')
        this.Data.maxDateExpire = moment(endDate).format('YYYY-MM-DD')
      } else {
        this.dateRange = { startDate: null, endDate: null }
        this.Data.minDateExpire = null
        this.Data.maxDateExpire = null
      }
    },
    updateAvlValues({ startDate, endDate } = {}) {
      if (startDate && endDate) {
        this.dateAvlRange = { startDate: moment(startDate), endDate: moment(endDate) }
        this.Data.minDateAvl = moment(startDate).format('YYYY-MM-DD')
        this.Data.maxDateAvl = moment(endDate).format('YYYY-MM-DD')
      } else {
        this.dateAvlRange = { startDate: null, endDate: null }
        this.Data.minDateAvl = null
        this.Data.maxDateAvl = null
      }
    },
    clearAvlDateRange() {
      this.dateAvlRange = { startDate: null, endDate: null }
      this.updateAvlValues()
    },
    clearExpireDateRange() {
      this.dateRange = { startDate: null, endDate: null }
      this.updateValues()
    },
    async onInput(value) {
      this.search = value

      if (!value || value.trim() === '') {
        this.filtered = []
        this.showSuggestions = false
        this.selectedPropertyId = null
        this.Data.place_id = null
        return
      }

      try {
        const response = await axios.post('/v1/house-pin/search', { keyword: value })
        this.filtered = response.data.data || []
        this.showSuggestions = true
        this.activeIndex = -1
      } catch (error) {
        console.error('API error:', error)
        this.filtered = []
      }
    },
    async onInputOwner(value) {
      this.showOwnerSuggestions = true
      this.activeIndexOwner = -1

      if (!value || value.trim() === '') {
        this.filteredOwner = []
        this.showOwnerSuggestions = false
        this.selectedOwnerId = null
        this.Data.owner_id = null
        return
      }

      axios.get(`/property/v1/owner/${value}`).then(response => {
        this.filteredOwner = response.data.data || []
      }).catch(() => {
        this.filteredOwner = []
      })
    },
    selectItem(index) {
      const selected = this.filtered[index]
      if (selected) {
        this.search = selected.name[this.currentLocale]
        this.selectedPropertyId = selected.id
        this.Data.place_id = selected.id
        this.showSuggestions = false
        this.filtered = []
        this.applyFilter(false)
      }
    },
    selectOwner(index) {
      const selected = this.filteredOwner[index]
      if (selected) {
        this.searchOwner = `${selected.firstname} ${selected.lastname}`
        this.selectedOwnerId = selected.id
        this.Data.owner_id = selected.id
        this.showOwnerSuggestions = false
        this.filteredOwner = []
        this.activeIndexOwner = -1
        this.applyFilter(false)
      }
    },
    moveDown() {
      if (this.activeIndex < this.filtered.length - 1) this.activeIndex++
    },
    moveUp() {
      if (this.activeIndex > 0) this.activeIndex--
    },
    moveDownOwner() {
      if (this.activeIndexOwner < this.filteredOwner.length - 1) this.activeIndexOwner++
    },
    moveUpOwner() {
      if (this.activeIndexOwner > 0) this.activeIndexOwner--
    },
    hideSuggestions() {
      setTimeout(() => { this.showSuggestions = false }, 160)
    },
    hideOwnerSuggestions() {
      setTimeout(() => { this.showOwnerSuggestions = false }, 160)
    },
    async getZones() {
      try {
        const res = await axios.post('zone/v1/lists', { perpage: 2000, offset: 0 })
        this.zoneOptions = res.data.data
      } catch (err) {
        console.error('Failed to load zones', err)
      }
    },
    async getBts() {
      try {
        const res = await axios.get('transit/v1/listtype/bts')
        this.bts = res.data.data
      } catch (err) {
        console.error('Failed to load BTS', err)
      }
    },
    async getMrt() {
      try {
        const res = await axios.get('transit/v1/listtype/mrt')
        this.mrt = res.data.data
      } catch (err) {
        console.error('Failed to load MRT', err)
      }
    },
    async getARL() {
      try {
        const res = await axios.post('transit/v1/lists', { type_code: 'airport' })
        this.arl = res?.data?.data
      } catch (err) {
        console.error('Failed to load ARL', err)
      }
    },
    async getAmenities() {
      try {
        const data = JSON.stringify({ perpage: 100, offset: 0, type_code: '2', keyword: null, is_active: 1 })
        const res = await axios.post('facility/v1/lists', data)
        this.amnls = res.data.data
      } catch (err) {
        console.error('Failed to load amenities', err)
      }
    },
    async getFacilities() {
      try {
        const data = JSON.stringify({ perpage: 100, offset: 0, type_code: '1', keyword: null, is_active: 1 })
        const res = await axios.post('facility/v1/lists', data)
        this.facs = res.data.data
      } catch (err) {
        console.error('Failed to load facilities', err)
      }
    },
    async getPlaceTypeData() {
      try {
        const res = await axios.post('v1/house/types', { is_active: 1 })
        const lang = this.$i18n ? this.$i18n.locale : 'en'

        const sortedData = res?.data?.data?.sort((a, b) => a.seq - b.seq) || []
        this.propertyTypeOptions = [{ id: null, title: 'All' }, ...sortedData].map(item => ({
          ...item,
          title: typeof item.title === 'object' ? item.title[lang] : item.title,
        }))
      } catch (err) {
        console.error('Failed to load place types', err)
      }
    },
    async fetchProvinces() {
      try {
        const res = await axios.get('address/v1/provinces')
        this.provinceOptions = (res?.data?.data || []).map(p => ({
          id: p.id,
          name: this.currentLocale === 'th' ? p.name_th : p.name_en,
        }))
      } catch (err) {
        console.error('Failed to load provinces', err)
      }
    },
    async onProvinceChange(provinceId) {
      this.amphureOptions = []
      this.Data.amphure_id = null
      if (!provinceId) return

      try {
        const res = await axios.get(`amphures/${provinceId}`)
        this.amphureOptions = (res?.data?.data || []).map(a => ({
          id: a.id,
          name: this.currentLocale === 'th' ? a.name_th : a.name_en,
        }))
      } catch (err) {
        console.error('Failed to load districts', err)
      }
    },
    fmt(val) {
      if (val === null || val === undefined || val === '') return ''
      const n = Number(String(val).replace(/,/g, ''))
      return isNaN(n) ? '' : n.toLocaleString('en-US')
    },
    onFmtInput(e, field) {
      const digits = e.target.value.replace(/\D/g, '')
      this.Data[field] = digits ? parseInt(digits, 10) : null
    },
    applyFilter(collapse = true) {
      const newQuery = {
        keyword: this.Data.keyword || undefined,
        actionId: this.Data.action_id || undefined,
        bedroom: this.Data.bedrooms || undefined,
        ownerId: this.Data.owner_id || undefined,
        minUseableArea: this.Data.sqm_min || undefined,
        maxUseableArea: this.Data.sqm_max || undefined,
        minLandArea: this.Data.min_land_area || undefined,
        maxLandArea: this.Data.max_land_area || undefined,
        minPrice: this.Data.priceMin || undefined,
        maxPrice: this.Data.priceMax || undefined,
        property_type: this.Data.property_type || undefined,
        bts_id: this.Data.bts_id || undefined,
        bts_ids: this.Data.bts_ids || undefined,
        mrt_id: this.Data.mrt_id || undefined,
        mrt_ids: this.Data.mrt_ids || undefined,
        arl_id: this.Data.arl_id || undefined,
        arl_ids: this.Data.arl_ids || undefined,
        zone_id: this.Data.zone_id || undefined,
        zones: this.Data.zones || undefined,
        amphure_id: this.Data.amphure_id || undefined,
        fac_id: this.Data.fac_id || undefined,
        amenity_id: this.Data.amenity_id || undefined,
        unit: this.Data.unit || undefined,
        floor: this.Data.floor || undefined,
        place_id: this.Data.place_id || undefined,
        expire_start: this.Data.minDateExpire || undefined,
        expire_end: this.Data.maxDateExpire || undefined,
        avl_start: this.Data.minDateAvl || undefined,
        avl_end: this.Data.maxDateAvl || undefined,
      }

      Object.keys(newQuery).forEach(k => newQuery[k] === undefined && delete newQuery[k])

      if (JSON.stringify(newQuery) !== JSON.stringify(this.$route.query)) {
        this.$router.replace({ query: newQuery }).catch(() => {})
      }

      if (collapse) this.collapsed = true
      this.$emit('refetch-data')
    },
    clearFilter() {
      this.actionSelected = []
      this.bedroomSelected = []
      this.BTSSelected = []
      this.MRTSelected = []
      this.ARLSelected = []
      this.zoneSelected = []
      this.facilitySelected = []
      this.amenitySelected = []
      this.dateRange = { startDate: null, endDate: null }
      this.dateAvlRange = { startDate: null, endDate: null }
      this.selectedRange = null
      this.selectedSqmRange = null
      this.selectedSqwRange = null

      this.search = ''
      this.selectedPropertyId = null
      this.searchOwner = ''
      this.selectedOwnerId = null

      this.Data.keyword = ''
      this.Data.action_id = ''
      this.Data.bedrooms = ''
      this.Data.property_type = null
      this.Data.priceMin = null
      this.Data.priceMax = null
      this.Data.sqm_min = ''
      this.Data.sqm_max = ''
      this.Data.min_land_area = null
      this.Data.max_land_area = null
      this.Data.bts_ids = ''
      this.Data.mrt_ids = ''
      this.Data.arl_ids = ''
      this.Data.zones = ''
      this.Data.minDateExpire = null
      this.Data.maxDateExpire = null
      this.Data.minDateAvl = null
      this.Data.maxDateAvl = null
      this.Data.bts_id = ''
      this.Data.mrt_id = ''
      this.Data.arl_id = ''
      this.Data.zone_id = ''
      this.Data.amphure_id = null
      this.selectedProvinceId = null
      this.amphureOptions = []
      this.Data.place_id = null
      this.Data.owner_id = null
      this.Data.unit = ''
      this.Data.floor = ''
      this.Data.fac_id = ''
      this.Data.amenity_id = ''

      if (Object.keys(this.$route.query).length) {
        this.$router.replace({ query: {} }).catch(() => {})
      }

      this.$emit('clear-search', this.Data)
    },
    onBTSChange() {
      const selected = this.BTSSelected.flatMap(item => item.toString().split(',').map(Number))
      if (selected.length === 1) {
        this.Data.bts_id = selected[0]
        this.Data.bts_ids = null
      } else {
        this.Data.bts_id = null
        this.Data.bts_ids = selected.join(',')
      }
    },
    onMRTChange() {
      const selected = this.MRTSelected.flatMap(item => item.toString().split(',').map(Number))
      if (selected.length === 1) {
        this.Data.mrt_id = selected[0]
        this.Data.mrt_ids = null
      } else {
        this.Data.mrt_id = null
        this.Data.mrt_ids = selected.join(',')
      }
    },
    onARLChange() {
      const selected = this.ARLSelected.flatMap(item => item.toString().split(',').map(Number))
      if (selected.length === 1) {
        this.Data.arl_id = selected[0]
        this.Data.arl_ids = null
      } else {
        this.Data.arl_id = null
        this.Data.arl_ids = selected.join(',')
      }
    },
    onFacilityChange() {
      const selected = this.facilitySelected.flatMap(item => item.toString().split(',').map(Number))
      this.Data.fac_id = selected.length === 1 ? selected[0] : selected.join(',')
    },
    onAmenityChange() {
      const selected = this.amenitySelected.flatMap(item => item.toString().split(',').map(Number))
      this.Data.amenity_id = selected.length === 1 ? selected[0] : selected.join(',')
    },
    onZoneChange() {
      const selected = this.zoneSelected.flatMap(item => item.toString().split(',').map(Number))
      if (selected.length === 1) {
        this.Data.zone_id = selected[0]
        this.Data.zones = null
      } else {
        this.Data.zone_id = null
        this.Data.zones = selected.join(',')
      }
    },
    toggleBedroom(i) {
      const idx = this.bedroomSelected.indexOf(i)
      if (idx > -1) {
        this.bedroomSelected.splice(idx, 1)
      } else {
        this.bedroomSelected.push(i)
      }
      this.Data.bedrooms = this.bedroomSelected.join(',')
    },
    toggleAction(value) {
      const index = this.actionSelected.indexOf(value)
      if (index > -1) {
        this.actionSelected.splice(index, 1)
      } else {
        this.actionSelected.push(value)
      }

      if (this.actionSelected.length === 0) {
        this.Data.action_id = ''
      } else {
        const allValues = this.actionSelected.flatMap(item => item.split(',').map(Number))
        const duplicates = [...new Set(allValues.filter((value, index, self) => self.indexOf(value) !== index))]
        this.Data.action_id = duplicates.length > 0 ? duplicates.join(',') : [...new Set(allValues)].join(',')
      }

      this.Data.priceMin = null
      this.Data.priceMax = null
      this.selectedRange = null
      this.showDropdown = false
    },
    openDropdown(type) {
      this.$nextTick(() => {
        this.showDropdown = false
        this.showSqmDropdown = false
        this.showSqwDropdown = false

        if (type === 'price') this.showDropdown = true
        if (type === 'sqm') this.showSqmDropdown = true
        if (type === 'sqw') this.showSqwDropdown = true
      })
    },
    closeDropdowns() {
      this.showDropdown = false
      this.showSqmDropdown = false
      this.showSqwDropdown = false
    },
    selectRange(range) {
      if (!range) return
      this.Data.priceMin = range.min ?? null
      this.Data.priceMax = range.max ?? null
      this.selectedRange = range
      this.showDropdown = false
    },
    selectSqmRange(range) {
      this.Data.sqm_min = range.min ?? null
      this.Data.sqm_max = range.max ?? null
      this.selectedSqmRange = range
      this.showSqmDropdown = false
    },
    selectSqwRange(range) {
      this.Data.min_land_area = range.min ?? null
      this.Data.max_land_area = range.max ?? null
      this.selectedSqwRange = range
      this.showSqwDropdown = false
    },
    handleClickOutside(event) {
      const priceDropdown = this.$refs.priceDropdownRef
      const sqmDropdown = this.$refs.sqmDropdownRef
      const sqwDropdown = this.$refs.sqwDropdownRef

      if (
        (priceDropdown && priceDropdown.contains(event.target)) ||
        (sqmDropdown && sqmDropdown.contains(event.target)) ||
        (sqwDropdown && sqwDropdown.contains(event.target))
      ) {
        return
      }

      this.closeDropdowns()
    },
    getPriceRage() {
      const ids = (this.Data.action_id || '').split(',').map(id => id.trim())
      return ids.includes('4') ? this.priceRentRanges : this.priceSaleRanges
    },
    clearChip(key) {
      const CLEAR = {
        keyword: () => { this.Data.keyword = '' },
        action: () => { this.Data.action_id = ''; this.actionSelected = [] },
        property_type: () => { this.Data.property_type = null },
        bedroom: () => { this.Data.bedrooms = ''; this.bedroomSelected = [] },
        price: () => { this.Data.priceMin = null; this.Data.priceMax = null; this.selectedRange = null },
        sqm: () => { this.Data.sqm_min = ''; this.Data.sqm_max = ''; this.selectedSqmRange = null },
        land: () => { this.Data.min_land_area = null; this.Data.max_land_area = null; this.selectedSqwRange = null },
        zone: () => { this.Data.zone_id = ''; this.Data.zones = ''; this.zoneSelected = [] },
        district: () => { this.Data.amphure_id = null; this.selectedProvinceId = null; this.amphureOptions = [] },
        bts: () => { this.Data.bts_id = ''; this.Data.bts_ids = ''; this.BTSSelected = [] },
        mrt: () => { this.Data.mrt_id = ''; this.Data.mrt_ids = ''; this.MRTSelected = [] },
        arl: () => { this.Data.arl_id = ''; this.Data.arl_ids = ''; this.ARLSelected = [] },
        unit: () => { this.Data.unit = '' },
        floor: () => { this.Data.floor = '' },
        owner: () => { this.Data.owner_id = null; this.searchOwner = '' },
        place: () => { this.Data.place_id = null; this.search = '' },
        facility: () => { this.Data.fac_id = ''; this.facilitySelected = [] },
        amenity: () => { this.Data.amenity_id = ''; this.amenitySelected = [] },
        expire: () => { this.Data.minDateExpire = null; this.Data.maxDateExpire = null; this.dateRange = { startDate: null, endDate: null } },
        updated: () => { this.Data.minDateAvl = null; this.Data.maxDateAvl = null; this.dateAvlRange = { startDate: null, endDate: null } },
      }
      if (CLEAR[key]) {
        CLEAR[key]()
        this.applyFilter()
      }
    },
    saveTemplate() {
      this.$swal({
        title: 'Save For Template',
        input: 'text',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
        inputAttributes: { autocapitalize: 'off' },
        showCancelButton: true,
        confirmButtonText: 'Save',
        showLoaderOnConfirm: true,
        preConfirm(login) {
          if (!login) return null
        },
      }).then((result) => {
        if (result.isConfirmed && result.value) {
          axios.post('/property/v1/add_template', { ...this.Data, created_by: this.userData.id, title: result.value }).then(() => {
            this.getTemplates()
            this.$toast({ component: ToastificationContent, props: { title: 'Done!', icon: 'BellIcon' } })
          }).catch(() => {
            this.$toast({ component: ToastificationContent, props: { title: 'Error!', icon: 'BellIcon' } })
          })
        }
      })
    },
    async getTemplates() {
      try {
        const templates = await axios.get('/property/v1/get_templates/' + this.userData.id)
        this.templateData = templates?.data?.data || []
        this.$emit('search-templates', this.templateData)
      } catch (err) {
        console.error('Failed to load templates', err)
      }
    },
    loadTemplate(t) {
      this.clearFilter()
      Object.keys(this.Data).forEach(k => { if (t[k] !== undefined) this.Data[k] = t[k] })

      if (t.action_id) this.actionSelected = t.action_id.toString().split(',').filter(Boolean)
      if (t.bedrooms) this.bedroomSelected = t.bedrooms.toString().split(',').map(Number)
      if (t.zones) this.zoneSelected = t.zones.toString().split(',').map(Number)
      if (t.bts_ids) this.BTSSelected = t.bts_ids.toString().split(',').map(Number)
      if (t.mrt_ids) this.MRTSelected = t.mrt_ids.toString().split(',').map(Number)
      if (t.arl_ids) this.ARLSelected = t.arl_ids.toString().split(',').map(Number)
      if (t.fac_id) this.facilitySelected = t.fac_id.toString().split(',').map(Number)
      if (t.amenity_id) this.amenitySelected = t.amenity_id.toString().split(',').map(Number)
      if (t.minDateExpire && t.maxDateExpire) {
        this.dateRange = { startDate: moment(t.minDateExpire), endDate: moment(t.maxDateExpire) }
      }
      if (t.minDateAvl && t.maxDateAvl) {
        this.dateAvlRange = { startDate: moment(t.minDateAvl), endDate: moment(t.maxDateAvl) }
      }
      if (t.place_id) this.filterPropertyId(t.place_id)
      if (t.owner_id) this.filterOwner(t.owner_id)

      this.$nextTick(() => this.applyFilter())
    },
    deleteTemplate(id) {
      this.$bvModal.msgBoxConfirm('Delete this template?', {
        title: 'Confirm', size: 'sm', okVariant: 'danger', okTitle: 'Yes', cancelTitle: 'No', centered: true,
      }).then(ok => {
        if (ok) axios.delete('/property/v1/delete_template/' + id).then(() => { this.getTemplates() })
      })
    },
    handleRouteChange(route) {
      if (route.query.actionId) {
        this.actionSelected = route.query.actionId === '2' ? [] : [route.query.actionId]
      }

      if (route.query.bedroom) {
        this.bedroomSelected = route.query.bedroom.split(',').map(Number)
      }

      if (route.query.place_id) {
        this.filterPropertyId(route.query.place_id)
      }

      if (route.query.ownerId) {
        this.filterOwner(route.query.ownerId)
      }

      if (route.query.expire_start && route.query.expire_end) {
        this.dateRange = { startDate: moment(route.query.expire_start), endDate: moment(route.query.expire_end) }
      }

      if (route.query.avl_start && route.query.avl_end) {
        this.dateAvlRange = { startDate: moment(route.query.avl_start), endDate: moment(route.query.avl_end) }
      }

      if (route.query.actionId) this.Data.action_id = route.query.actionId
      if (route.query.bedroom) this.Data.bedrooms = route.query.bedroom
      if (route.query.property_type) this.Data.property_type = route.query.property_type
      if (route.query.minPrice) this.Data.priceMin = route.query.minPrice
      if (route.query.maxPrice) this.Data.priceMax = route.query.maxPrice
      if (route.query.minUseableArea) this.Data.sqm_min = route.query.minUseableArea
      if (route.query.maxUseableArea) this.Data.sqm_max = route.query.maxUseableArea
      if (route.query.minLandArea) this.Data.min_land_area = route.query.minLandArea
      if (route.query.maxLandArea) this.Data.max_land_area = route.query.maxLandArea
      if (route.query.bts_ids) this.Data.bts_ids = route.query.bts_ids
      if (route.query.mrt_ids) this.Data.mrt_ids = route.query.mrt_ids
      if (route.query.arl_ids) this.Data.arl_ids = route.query.arl_ids
      if (route.query.zones) this.Data.zones = route.query.zones
      if (route.query.expire_start) this.Data.minDateExpire = route.query.expire_start
      if (route.query.expire_end) this.Data.maxDateExpire = route.query.expire_end
      if (route.query.avl_start) this.Data.minDateAvl = route.query.avl_start
      if (route.query.avl_end) this.Data.maxDateAvl = route.query.avl_end
      if (route.query.bts_id) this.Data.bts_id = route.query.bts_id
      if (route.query.mrt_id) this.Data.mrt_id = route.query.mrt_id
      if (route.query.arl_id) this.Data.arl_id = route.query.arl_id
      if (route.query.zone_id) this.Data.zone_id = route.query.zone_id
      if (route.query.amphure_id) this.Data.amphure_id = route.query.amphure_id
      if (route.query.place_id) this.Data.place_id = route.query.place_id
      if (route.query.ownerId) this.Data.owner_id = route.query.ownerId
      if (route.query.unit) this.Data.unit = route.query.unit
      if (route.query.floor) this.Data.floor = route.query.floor
      if (route.query.fac_id) this.Data.fac_id = route.query.fac_id
      if (route.query.amenity_id) this.Data.amenity_id = route.query.amenity_id

      const parseIdList = (key1, key2, target) => {
        if (route.query[key1]) {
          this[target] = route.query[key1].split(',').map(Number)
        } else if (key2 && route.query[key2]) {
          this[target] = route.query[key2].split(',').map(Number)
        }
      }

      parseIdList('bts_id', 'bts_ids', 'BTSSelected')
      parseIdList('mrt_id', 'mrt_ids', 'MRTSelected')
      parseIdList('arl_id', 'arl_ids', 'ARLSelected')
      parseIdList('zone_id', 'zones', 'zoneSelected')
      parseIdList('fac_id', '', 'facilitySelected')
      parseIdList('amenity_id', '', 'amenitySelected')
    },
  },
  watch: {
    '$route.query': {
      handler(newQuery) {
        this.handleRouteChange({ query: newQuery })
      },
      deep: true,
      immediate: false,
    },
  },
}
</script>

<style scoped>
.filter-topbar { border-bottom: 1px solid #ebe9f1; }

/* Active filter capsules */
.capsule-row { display: flex; flex-wrap: wrap; align-items: center; background: transparent; }
.capsule-tag {
  display: inline-flex;
  align-items: center;
  padding: 0.3rem 0.65rem;
  border-radius: 20px;
  font-size: 0.8rem;
  font-weight: 500;
  background: #e6f4ea;
  color: #2d7a3a;
  border: 1px solid #a8d5b0;
  cursor: pointer;
  transition: background 0.15s, opacity 0.15s;
  gap: 0.2rem;
}
.capsule-tag:hover { background: #d0ecd6; }
.capsule-label { color: #5da867; font-weight: 400; margin-right: 0.2rem; }
.capsule-value { font-weight: 600; }
.capsule-x { opacity: 0.6; flex-shrink: 0; }
.capsule-clear { background: #fff0f0; color: #e63946; border-color: #f5c6cb; }
.capsule-clear:hover { background: #ffd6d6; }

/* Desktop top bar fields */
.topbar-input-label { display: block; font-size: 0.72rem; font-weight: 600; color: #5e5873; margin-bottom: 0.25rem; white-space: nowrap; }
.topbar-field-code { min-width: 180px; flex: 2; }
.topbar-field-owner { min-width: 140px; flex: 1.5; }
.topbar-field-sm { width: 130px; flex-shrink: 0; }
.topbar-icon-btn { padding: 0.4rem 0.5rem !important; line-height: 1 !important; border: none !important; box-shadow: none !important; }
.topbar-clearable { padding-right: 1.4rem !important; }
.topbar-clear-btn { position: absolute; right: 0.45rem; top: 50%; transform: translateY(-50%); cursor: pointer; color: #6e6b7b; background: #d8d6de; border-radius: 50%; width: 16px; height: 16px; display: flex; align-items: center; justify-content: center; flex-shrink: 0; z-index: 2; }
.topbar-clear-btn:hover { background: #ea5455; color: #fff; }

.field-label {
  display: block;
  font-size: 0.857rem;
  font-weight: 600;
  margin-bottom: 0.3rem;
}

/* Action / Bedroom toggle */
.toggle-group { overflow: hidden; display: flex; }
.toggle-btn { flex: 1; border: none !important; box-shadow: none !important; border-radius: 0 !important; }

/* Price / SQM / Land range group */
.range-group { border: 1px solid #d8d6de; border-radius: 0.357rem; }
.range-group .form-control { border: none !important; box-shadow: none !important; border-radius: 0 !important; }
.range-sep { border: none !important; background: transparent !important; }
.range-dropdown { position: absolute; top: calc(100% + 4px); left: 0; right: 0; z-index: 9999; }

/* Facility / Amenity checkbox grid */
.checkbox-grid {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0.5rem;
  padding: 0.5rem 0;
}
@media (max-width: 768px) { .checkbox-grid { grid-template-columns: repeat(3, 1fr); } }
@media (max-width: 480px) { .checkbox-grid { grid-template-columns: repeat(2, 1fr); } }

@media (max-width: 575px) {
  .filter-toggle-btn { border: none !important; background: transparent !important; box-shadow: none !important; padding-left: 0.25rem; padding-right: 0.25rem; }
}

.zindex-dropdown { z-index: 1050; }
.list-group-item.active { background-color: #80AC03; color: #fff; }

.kw-clear-wrap { background: #fff; border-left: none !important; border-right: none !important; padding: 0 6px; cursor: pointer; }
.kw-clear-circle { background: #d8d6de; border-radius: 50%; width: 16px; height: 16px; display: flex; align-items: center; justify-content: center; color: #6e6b7b; flex-shrink: 0; }
.kw-clear-circle:hover { background: #ea5455; color: #fff; }

.reportrange-text { padding: 0.438rem 1rem !important; border: 1px solid #d8d6de !important; border-radius: 0.357rem !important; }
</style>
